module.exports = __webpack_public_path__ + "media/application/images/svgs/trending-down-02fa4585033d7ffdd8b322c6527decbb.svg";